<template>
  <a-select
    v-bind="$attrs"
    v-on="$listeners"
    :value="selectValue"
    :allowClear="allowClear"
    :getPopupContainer="getPopupContainer"
    :placeholder="placeholder"
    :dropdownMenuStyle="dropdownMenuStyle"
    :mode="mode"
  >
    <!-- -->
    <a-select-option
      v-for="item in optionList"
      :key="item[optionValue]"
      :value="item[optionValue]"
    >
      {{ item[optionLabel] }}
    </a-select-option>
  </a-select>
</template>
<script>
import { getSelect } from "@/plugins/select-option/util";
export default {
  name: "z-select",
  props: {
    value: {
      type: [String, Number, Array],
      default: undefined,
    },
    optionName: {
      type: [String, Object], // select-options 对应的key
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    optionLabel: {
      type: String,
      default: "label", // select-option渲染label 的 key
    },
    optionValue: {
      type: String,
      default: "value", // select-option渲染value 的 key
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    autoValue: {
      // 默认选中第一项
      type: Boolean,
      default: false,
    },
    dropdownMenuStyle: {
      // 自定义下拉框菜单样式
      type: Object,
      default: () => {
        return { maxHeight: "300px" };
      },
    },
    getPopupContainer: {
      type: Function,
      default: (triggerNode) => triggerNode.parentNode,
    },
    // 设置 Select 的模式为多选或标签'default' | 'multiple' | 'tags' | 'combobox'
    mode: {
      type: String,
      default: "default",
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      optionList: [],
      timer: null,
    };
  },
  created() {
    this.changeOptionList();
  },
  computed: {
    selectValue() {
      let v = this.value;
      if (this.value === null || this.value === "") v = undefined;
      return v;
    },
  },
  mounted() {},
  methods: {
    // 重置当前value为
    resetToFirst() {
      this.emitValue(this.optionList[0][this.optionValue]);
    },
    async changeOptionList() {
      try {
        let list = [];
        if (this.optionName) {
          list = [...(await getSelect(this.optionName))];
        }
        this.optionList = [...this.options, ...list];
        if (this.autoValue && this.optionList.length) {
          // 需要重置到第一项
          this.resetToFirst();
        }
        // 初始化List成功 数据抛出，具体使用交给调用者
        this.$emit("initOptions", this.optionList);
      } catch (error) {
        this.$emit("initOptions", this.optionList);
      }
    },
    emitValue(val) {
      this.$emit("change", this.$attrs.mode === "multiple" ? [val] : val);
    },
  },
  watch: {
    options() {
      this.changeOptionList();
    },
  },
};
</script>
<style lang="scss" scoped>
.ant-select {
  min-width: 150px;
}
</style>
